import { SidebarMenuSkeleton, SidebarMenuSubItem } from '@/components/ui/sidebar';

import SidebarAppsList from './SidebarAppsList';

const SKELETON_ROWS = 3;

const SidebarAppsSkeleton = () => (
  <SidebarAppsList data-testid="sidebar-apps-skeleton">
    {Array.from({ length: SKELETON_ROWS }, (_, index) => (
      <SidebarMenuSubItem key={index}>
        <SidebarMenuSkeleton showIcon className="h-8 px-2.5" />
      </SidebarMenuSubItem>
    ))}
  </SidebarAppsList>
);

export default SidebarAppsSkeleton;
